export default __webpack_public_path__ + "static/media/anugata2.cd0cdadd.png";